/**
 * URL patterns passed to Sentry's `denyUrls`. An event is dropped when the
 * origin of its crashing stack frame matches one of these. Use this (not
 * `ignoreErrors`) for errors thrown entirely inside a third-party script, where
 * the message is too generic to filter on safely.
 */
export const sentryDenyUrls: (string | RegExp)[] = [
  /js\.hubspot\.com/,
  // Google reCAPTCHA internal errors (WEBAPP-CC1, WEBAPP-CC2): crashes inside
  // Google's minified recaptcha__en.js (e.g. "Cannot read properties of
  // undefined (reading 'SO')" / "(reading 'II')") surface only because
  // @sentry/browser wraps global callbacks. Not our code — no OnFrontiers frame
  // appears in the stack. The message is too generic for `ignoreErrors`, so
  // filter on the origin URL (matches every reCAPTCHA release bundle).
  /\/recaptcha\//,
];
